import { api } from './apiClient';

export const sendFestivalNotification = async (payload) => {
  try {
    const response = await api.post('/api/v1/admin/notifications/send-festival', payload);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const getNotificationHistory = async (payload) => {
  try {
    const response = await api.post('/api/v1/admin/notifications/list', payload);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};
